import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';

import system from './system';
import translations from './translations';
import header from './header';
import footer from './footer';

/**
 * Connect reducers to the redux store.
 */

/* istanbul ignore next */
const reducers = combineReducers({
    system,
    translations,
    header,
    footer,
    form: formReducer
});

export default reducers;
